import { AddDeliveryAddressState } from './addDeliveryAddress.types'

const initialState: AddDeliveryAddressState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
